import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import device from "./modules/device";
import getters from './getters'

Vue.use(Vuex);
const resetPlugin = (store) => {
  window.addEventListener('beforeunload', () => {
    store.commit('resetNumberP');
    store.commit('clearGoodsks');
  });
};

const store = new Vuex.Store({
  state: {
    numberP: '',
    numberK: '',
    goodsks: [],
    gybj:[],
    isButtonVisible: true,
  },
  modules: {
    user,
    device
  },
  getters,
  mutations: {
    resetNumberP(state) {
      state.numberP = 0;
      state.numberK = 0;
    },
    clearGoodsks(state) {
      state.goodsks = [];
    },
    addToGoodsks(state, id) {
      state.goodsks.push(id);
    },
    setButtonVisibility(state, value) {
      state.isButtonVisible = value;
    },
    showButton(state) {
      state.isButtonVisible = true; // 设置为显示
    }
  },
  plugins: [resetPlugin]
});

export default store;
